// extracted by mini-css-extract-plugin
export default {"autocomplete":"rL2XUyH3JjWdXCEQ5TMi","team":"BFMrVarEsWHmPTStwMAC","name":"XOUvElxNkxH6wqN4LCod"};